import React from "react";

const IconLikeSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.28688 17.3146C9.19733 17.1633 9.15183 16.9893 9.15564 16.8129C9.15945 16.6364 9.21241 16.4647 9.30841 16.3174L12.0115 12.1727L8.32436 8.96788C8.15887 8.82408 8.04894 8.62551 8.01404 8.40736C7.97914 8.18922 8.02153 7.96559 8.13371 7.77611L10.7808 3.3034C9.7223 2.45992 8.41532 2.00096 7.06909 2C3.71719 2 1 4.7546 1 8.15404C1 8.63549 1.06027 9.10196 1.1636 9.55161C2.00619 14.8612 7.82742 20.4621 11.9998 22C12.0151 21.9944 12.0317 21.9863 12.0471 21.98L9.28688 17.3146Z"
        fill="white"
      />
      <path
        d="M16.9311 2C15.2306 2 13.7035 2.7178 12.6032 3.86031L10.1173 8.06174L13.8314 11.2897C14.002 11.4381 14.1132 11.6446 14.1443 11.8704C14.1753 12.0962 14.124 12.3257 13.9999 12.5157L11.1683 16.8575L13.7275 21.1824C17.6255 18.9816 22.1048 14.1584 22.8354 9.55223C22.94 9.10259 23.0002 8.63611 23.0002 8.15466C22.9996 4.7546 20.2824 2 16.9311 2Z"
        fill="white"
      />
    </svg>
  );
};

export default IconLikeSvg;
